export default {
  title: 'MAXHUB 장치 활성화',
  instruction: '사용자 정보를 정확히 입력하십시오. 추후 A/S 발생시 문제가 발생할 수 있습니다',
  dealername: '대리점',
  dealerplaceholder: '대리점명(필수)',
  companyname: '회사명',
  companyplaceholder: '회사명(필수)',
  tele: '연락처',
  teleplaceholder: '고객연락처(필수)',
  district: '지역선택',
  distplaceholder: '지역정보(필수)',
  address: '상세주소',
  addrplaceholder: '거리정보(필수)',
  activebtn: '활성화코드',
  confirmbtn: '확인',
  cancelbtn: '취소',
  dialogmessage: '입력하신 전화 번호의 형식이 잘못되었습니다. 다시 입력하십시오',
  dialogbtn: '확인',
  errortitle: '열수 없습니다',
  errorinfo1: '네트워크를 확인하십시오',
  errorinfo2: '고객서비스 연락처 : 400-168-9545',
  nosn: '본 기기에 SN코드 없는 이유로 활성화 할 수 없습니다',
  activepagetitle: '활성화코드',
  activepagehint: '활성화 코드를 입력하여 기기를 활성화 하여야 합니다',
  finish: '완성하다',
  search: '위치 검색'
};



// WEBPACK FOOTER //
// ./src/i18n/_ko.js